<mat-radio-group
  [formControl]="controlname"
  (change)="onInput.emit($event.value)"
  color="primary"
  [ngClass]="{ 'dark-label': isDarkMode() }"
>
  <div class="horizontal-radio-group">
    <mat-radio-button
      *ngFor="let option of options"
      [value]="option.value"
       [disabled]="option.disabled"
      [ngClass]="{
        'invalid-radio':
          formSubmitted &&
          controlname?.invalid &&
          !controlname?.hasError('pattern')
      }"
    >
      <span class="labelName">{{ option.label }}</span>
    </mat-radio-button>
  </div>
</mat-radio-group>
<div
  *ngIf="
    formSubmitted && controlname?.invalid && !controlname?.hasError('pattern')
  "
  class="error-message"
>
  <p class="ename">{{ errorMessage }}</p>
</div>
